import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FeedbackEmotionScale4 = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M10.271 19.683C10.271 19.683 10.295 19.708 10.298 19.712C10.562 19.974 12.709 22 16 22C19.291 22 21.438 19.974 21.702 19.712C21.705 19.709 21.729 19.683 21.729 19.683C21.897 19.504 22 19.264 22 19C22 18.448 21.552 18 21 18C20.714 18 20.457 18.12 20.275 18.313C20.275 18.313 18.626 20 16 20C13.385 20 11.725 18.313 11.725 18.313C11.543 18.121 11.285 18 11 18C10.448 18 10 18.448 10 19C10 19.265 10.104 19.504 10.271 19.683V19.683Z" />
		<path d="M23 16C22.448 16 22 15.552 22 15C22 14.448 21.551 14 21 14C20.449 14 20 14.449 20 15C20 15.552 19.552 16 19 16C18.448 16 18 15.552 18 15C18 13.346 19.346 12 21 12C22.654 12 24 13.346 24 15C24 15.552 23.552 16 23 16Z" />
		<path d="M13 16C12.448 16 12 15.552 12 15C12 14.448 11.551 14 11 14C10.449 14 10 14.449 10 15C10 15.552 9.552 16 9 16C8.448 16 8 15.552 8 15C8 13.346 9.346 12 11 12C12.654 12 14 13.346 14 15C14 15.552 13.552 16 13 16Z" />
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
	</svg>
);

export default FeedbackEmotionScale4;
